interface Props {
  children: string
}

export const CodeBox = ({ children }: Props) => {
  return <code className="rounded bg-border p-1 font-menlo text-[10px]">{children}</code>
}
